const LOCATION_FIELD_MAP: Record<string, string> = {
  street_number: "number",
};

export const normalizeLocationField = (field: string): string =>
  LOCATION_FIELD_MAP[field] ?? field;

export const buildLocationLike = (field: string, value: string): [string, string, string] => [
  "like",
  normalizeLocationField(field),
  `%${value}%`,
];
